import { render, staticRenderFns } from "./ActiveClient.vue?vue&type=template&id=3fa9867d&"
import script from "./ActiveClient.vue?vue&type=script&lang=js&"
export * from "./ActiveClient.vue?vue&type=script&lang=js&"
import style0 from "./ActiveClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports